import { Autocomplete, Checkbox, ListItemText, TextField } from "@mui/material";

const getCommaSeparatedSummary = (values = [], maxChars = 32) => {
  if (!Array.isArray(values) || values.length === 0) return "";
  const mapped = values
    .map((v) => v?.label || v?.name || v?.value || v)
    .filter(Boolean);
  const text = mapped.join(", ");
  if (text.length <= maxChars) return text;
  const truncated = text.slice(0, maxChars - 1);
  return `${truncated}…`;
};

const MultiSelectAutoComplete = ({
  label,
  options,
  value,
  onChange,
  setIsCallApiForView,
}) => {
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={[
        { sentinel: "__SELECT_ALL__", label: "Select All" },
        { sentinel: "__CLEAR__", label: "Clear" },
        ...options,
      ]}
      value={value}
      isOptionEqualToValue={(option, value) => {
        if (option?.sentinel && value?.sentinel)
          return option.sentinel === value.sentinel;
        return (
          (option?.id ?? option?.value ?? option) ===
          (value?.id ?? value?.value ?? value)
        );
      }}
      renderTags={() =>
        getCommaSeparatedSummary(
          (value || []).map((m) => m?.name || m?.label || m?.value || m),
          14
        )
      }
      getOptionLabel={(option) =>
        option?.label || option?.name || option?.value || option
      }
      onBlur={() =>
        setTimeout(() => setIsCallApiForView && setIsCallApiForView(true), 200)
      }
      onChange={(event, newValue, reason, details) => {
        const toggled = details?.option;
        setIsCallApiForView && setIsCallApiForView(false);

        // Handle select all
        if (toggled?.sentinel === "__SELECT_ALL__") {
          onChange(options);
          return;
        }

        // Handle clear
        if (toggled?.sentinel === "__CLEAR__") {
          onChange([]);
          setIsCallApiForView && setIsCallApiForView(true);
          return;
        }

        // Handle normal selection
        const cleaned = newValue.filter((v) => !v?.sentinel);
        onChange(cleaned);
      }}
      renderOption={(props, option, { selected }) => (
        <li
          {...props}
          key={option?.sentinel || option?.id || option?.value || option?.label}
        >
          <Checkbox checked={selected} />
          <ListItemText
            primary={
              option?.label ||
              option?.name ||
              option?.value ||
              option?.sentinel ||
              ""
            }
          />
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} size="small" label={label} />
      )}
      sx={{ width: 300 }}
    />
  );
};

export default MultiSelectAutoComplete;
